import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

class PrimaryNavItem extends React.Component {
  static propTypes = {
    menuId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    iconName: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    active: PropTypes.bool,
    handleMouseEnter: PropTypes.func,
    hover: PropTypes.bool,
  };

  static defaultProps = {
    active: false,
    hover: false,
    handleMouseEnter: null,
  };

  constructor(props) {
    super(props);
    this.handleOnMouseEnter = this.handleOnMouseEnter.bind(this);
  }

  handleOnMouseEnter = () => {
    const { name, handleMouseEnter } = this.props;
    handleMouseEnter(name);
  }

  render() {
    const { name, menuId, iconName, active, link, hover } = this.props;
    const hoverClass = hover ? styles.hover : '';
    const activeClass = active ? styles.active : '';

    return (
      <a
        onMouseEnter={this.handleOnMouseEnter}
        onMouseLeave={this.handleOnMouseLeave}
        className={`${styles.navItem} ${hoverClass} ${activeClass} ${(menuId === 'emergency' ? styles.emergencyFeatures : '')} `}
        key={name}
        href={link}
      >
        {!!(iconName.length) && <img src={`/images/app/nav/${iconName}.svg`} alt={name} />}
        {name}
      </a>
    );
  }
}

export default PrimaryNavItem;
